import { io } from 'socket.io-client';

let socket;

function resolveSocketBase() {
  if (typeof window === 'undefined') return 'http://localhost:5000';
  const { hostname, protocol } = window.location;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:5000`;
  }
  // Same-origin in production
  return '/';
}

export function connectSocket(token) {
  if (socket && socket.connected) return socket;
  const base = process.env.REACT_APP_SOCKET_URL || resolveSocketBase();
  socket = io(base, { auth: { token }, withCredentials: true });
  return socket;
}

export function onSocketEvents(handlers = {}) {
  if (!socket) return;
  const { onConversationCreated, onConversationUpdated, onMessageCreated, onTyping, onConversationDeleted } = handlers;
  if (onConversationCreated) socket.on('conversation:created', onConversationCreated);
  if (onConversationUpdated) socket.on('conversation:updated', onConversationUpdated);
  if (onMessageCreated) socket.on('message:created', onMessageCreated);
  if (onTyping) socket.on('typing', onTyping);
  if (onConversationDeleted) socket.on('conversation:deleted', onConversationDeleted);
}

export function offSocketEvents(handlers = {}) {
  if (!socket) return;
  const { onConversationCreated, onConversationUpdated, onMessageCreated, onTyping, onConversationDeleted } = handlers;
  if (onConversationCreated) socket.off('conversation:created', onConversationCreated);
  if (onConversationUpdated) socket.off('conversation:updated', onConversationUpdated);
  if (onMessageCreated) socket.off('message:created', onMessageCreated);
  if (onTyping) socket.off('typing', onTyping);
  if (onConversationDeleted) socket.off('conversation:deleted', onConversationDeleted);
}

export function joinConversationRoom(id) {
  if (!socket) return;
  socket.emit('conversation:join', id);
}

export function leaveConversationRoom(id) {
  if (!socket) return;
  socket.emit('conversation:leave', id);
}

export function disconnectSocket() {
  if (socket) socket.disconnect();
  socket = undefined;
}

export function sendTyping(conversationId, isTyping) {
  if (!socket) return;
  socket.emit('typing', { conversationId, isTyping: !!isTyping });
}
